<template>
  <tr>
    <td class="border px-1 md:px-4 py-2">
      <template v-if="consistenza">
        <p>{{ descrizione }}</p>
        <p v-if="piani">{{ piani }}</p>
      </template>
    </td>
    <td class="border px-1 md:px-4 py-2 text-center">
      <template v-if="consistenza">
        <p v-if="superficie">{{ superficie }} m<sup>2</sup></p>
      </template>
    </td>
    <td class="border px-1 md:px-4 py-2 text-center">
      <template v-if="consistenza">
        <p v-if="frazione">{{ frazione }}</p>
      </template>
    </td>
    <td class="border px-1 md:px-4 py-2 text-center">
      <template v-if="consistenza">
        <p v-if="peso">{{ peso }}</p>
      </template>
      <template v-else>
        totale
      </template>
    </td>
    <td class="border px-1 md:px-4 py-2 text-right">
      <template v-if="consistenza">
        <p>{{ totale(consistenza) }} m<sup>2</sup></p>
      </template>
      <template v-else>
        {{ sommaTotale }} m<sup>2</sup>
      </template>
    </td>
  </tr>
</template>

<script>
export default {
  name: "Consistenza",
  props: ['consistenza', 'consistenze'],
  computed: {
    descrizione() {
      let str = this.consistenza.Consistenze
          ? this.consistenza.Consistenze.Descrizione.Voce + ' '
          : ''
      str += this.consistenza.Descrizione
          ? this.consistenza.Descrizione
          : ''
      return str
    },
    piani() {
      return this.consistenza.Piani
          ? 'Piano: ' + this.consistenza.Piani.Descrizione
          : false;
    },
    superficie() {
      return this.consistenza.Superficie
          ? this.consistenza.Superficie
          : false
    },
    frazione() {
      return this.consistenza.Denominatore && this.consistenza.Numeratore
          ? `${this.consistenza.Numeratore} / ${this.consistenza.Denominatore}`
          : false
    },
    peso() {
      return this.consistenza.Peso
          ? `${this.consistenza.Peso}%`
          : false
    },
    sommaTotale() {
      return this.toFixedIfNecessary(this.consistenze.map(c => this.totale(c)).reduce((a, b) => a + b, 0), 2)
    }
  },
  methods: {
    totale(consistenza) {
      return this.toFixedIfNecessary(
          consistenza.Superficie * (consistenza.Numeratore / consistenza.Denominatore) * (consistenza.Peso / 100),
          2
      )
    },
    toFixedIfNecessary( value, dp ){
      return +parseFloat(value).toFixed( dp );
    }
  }
}
</script>

<style scoped>

</style>
